import { toast } from '@/lib/hooks/useToast.ts'
import i18n from '@/i18n.ts'

export default function showErrorToast(description?: string, title?: string) {
  toast({
    variant: 'destructive',
    title: title ?? '🚨 ' + i18n.t('error.somethingWrong'),
    description: description ?? i18n.t('error.tryAgain'),
  })
}
